import {
  Mapping,
  ModelConceptRelationship,
} from 'src/containers/ProjectDiagram/types/data';
import { Model } from 'src/containers/ProjectDiagram/types/model';
import { isModelConceptRelationship } from 'src/containers/ProjectDiagram/utils/data';
import { addMappingsToConnectedValidRelationships } from 'src/containers/ProjectDiagram/utils/mapping/addMappingsToConnectedValidRelationships';
import { isValidMapping } from 'src/containers/ProjectDiagram/utils/mapping/isValidMapping';

/** called when a class mapping becomes a valid mapping
 * this adds mappings to all valid relationships connected to the
 * target class of the class mapping
 */
export const maybeMapRelationshipsRelatedToValidClassMapping =
  (mapping: Mapping) => (model: Model) => {
    if (
      !isValidMapping(mapping)(model) ||
      !model.nodeDataArray.find((nodeData) => nodeData.key === mapping.to)
    ) {
      return;
    }

    const mappableRelationships = model.linkDataArray.filter(
      (linkData): linkData is ModelConceptRelationship =>
        isModelConceptRelationship(linkData) &&
        Boolean(linkData.from === mapping.to || linkData.to === mapping.to)
    );

    addMappingsToConnectedValidRelationships(mappableRelationships)(model);
  };
